var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.2,20.9c-0.3,0-0.6-0.1-0.9-0.4c-0.3-0.3-0.4-0.7-0.2-1.1l1.2-3.7c-1.2-2-1.6-4.2-1.1-6.4c0.5-2.4,1.9-4.5,4-6\n\tC6.3,1.7,8.9,1,11.5,1.1c2.6,0.1,5.1,1.1,7.1,2.7c1.9,1.7,3.2,3.9,3.4,6.3c0.2,2.4-0.5,4.8-2.1,6.8c-1.6,1.9-3.9,3.3-6.5,3.8\n\tc-2.4,0.5-5,0.2-7.2-0.8l-4.8,1C1.3,20.9,1.2,20.9,1.2,20.9z M6.3,17.5c0.2,0,0.3,0,0.5,0.1c1.9,0.9,4,1.2,6.1,0.8\n\tc2.1-0.4,3.9-1.5,5.1-3c1.2-1.5,1.8-3.3,1.6-5.1c-0.2-1.8-1.1-3.5-2.6-4.8c-1.5-1.3-3.5-2.1-5.7-2.1C9.3,3.3,7.2,3.9,5.5,5.1\n\tC3.9,6.2,2.8,7.9,2.5,9.7c-0.4,1.8,0,3.6,1.1,5.2c0.2,0.3,0.3,0.7,0.1,1l-0.8,2.3l3.2-0.7C6.1,17.5,6.2,17.5,6.3,17.5z"}));
}

Chat.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 22 22","style":{"enableBackground":"new 0 0 22 22"},"xmlSpace":"preserve"};

module.exports = Chat;

Chat.default = Chat;
